export default Object.freeze({
  AllCurrentChildren: 'all-current-children',
  ChildrenStartedBySpecificAction: 'children-started-by-specific-action',
});
